import cForm from './cForm.vue';

export default {
  install(Vue) {
    Vue.component('cForm', cForm);
  },
};
